import React, { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";

const STORAGE_KEY = "beta_banner_dismissed";

export function BetaBanner() {
  const [visible, setVisible] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (typeof localStorage === "undefined") return;
    if (!user) return;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) setVisible(true);
  }, [user]);

  function handleDismiss() {
    localStorage.setItem(STORAGE_KEY, "true");
    setVisible(false);
  }

  if (!visible || !user) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 64,
        left: 0,
        right: 0,
        zIndex: 40,
        background: "#1a1a1a",
        borderBottom: "1px solid #333",
        fontFamily: "'DM Sans', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "10px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
        }}
      >
        <p style={{ color: "#a1a1aa", fontSize: 14, margin: 0 }}>
          <span style={{ color: "#6366f1", fontWeight: 500 }}>Beta</span>
          {" • "}
          Bugs may happen. Email{" "}
          <a
            href="mailto:support@usedayone.net"
            style={{ color: "#6366f1", textDecoration: "underline" }}
          >
            support@usedayone.net
          </a>
          {" "}if you hit any.
        </p>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          style={{
            position: "absolute",
            right: 16,
            background: "transparent",
            border: "none",
            color: "#666",
            fontSize: 18,
            cursor: "pointer",
            padding: "4px 8px",
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
}
